export default function loadState ({ next, store }){
    if (! store.state.auth.stateIsReady) {
        store.dispatch('auth/loadUser').then(() => {
            next()
        })
    } else {
        next()
    }
}
